import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PremierPartners = () => {
  const premierPartners = [
  {
    id: 1,
    name: "Microsoft",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_126b4a65e-1765267890589.png",
    logoAlt: "Microsoft logo featuring four colored squares in red, green, blue and yellow arranged in a grid pattern on white background",
    tier: "Gold Partner",
    since: "2015",
    certifications: ["Azure Solutions", "Microsoft 365", "Dynamics 365", "Power Platform"],
    description: "Delivering enterprise cloud solutions, productivity platforms, and business applications with Microsoft's cutting-edge technology stack.",
    integrations: 25,
    projects: 87,
    icon: "Cloud"
  },
  {
    id: 2,
    name: "Zoho",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b120cb1d-1766763601067.png",
    logoAlt: "Zoho logo with distinctive orange and white branding displayed on modern digital interface with clean geometric design",
    tier: "Premium Partner",
    since: "2016",
    certifications: ["Zoho CRM", "Zoho One", "Zoho Creator", "Zoho Analytics"],
    description: "Implementing comprehensive business management solutions with Zoho\'s integrated suite of cloud applications for seamless operations.",
    integrations: 18,
    projects: 64,
    icon: "Layers"
  },
  {
    id: 3,
    name: "Acronis",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14096337d-1766763600325.png",
    logoAlt: "Acronis cybersecurity shield logo in teal and black colors representing data protection and backup solutions on gradient background",
    tier: "Elite Partner",
    since: "2017",
    certifications: ["Cyber Protect", "Backup Cloud", "Disaster Recovery", "Cyber Infrastructure"],
    description: "Providing enterprise-grade cybersecurity, backup, and disaster recovery solutions with Acronis's industry-leading protection technology.",
    integrations: 15,
    projects: 52,
    icon: "Shield"
  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Star" size={18} color="var(--color-primary)" />
            <span className="text-primary text-sm font-medium">Premier Technology Alliances</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Strategic Partnership Ecosystem
          </h2>
          <p className="text-text-secondary text-sm md:text-base lg:text-lg max-w-3xl mx-auto">
            Certified partnerships with industry leaders ensuring enterprise-grade solutions, seamless integrations, and comprehensive support for your digital transformation journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {premierPartners?.map((partner) =>
          <div
            key={partner?.id}
            className="bg-card rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">

              <div className="relative h-48 md:h-56 lg:h-64 bg-gradient-to-br from-primary/5 to-secondary/5 flex items-center justify-center p-8">
                <Image
                src={partner?.logo}
                alt={partner?.logoAlt}
                className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300" />

                <div className="absolute top-4 right-4 bg-white rounded-full p-3 shadow-md">
                  <Icon name={partner?.icon} size={24} color="var(--color-primary)" />
                </div>
              </div>

              <div className="p-6 md:p-8">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl md:text-2xl font-bold text-foreground">{partner?.name}</h3>
                  <div className="flex items-center gap-1">
                    <Icon name="Award" size={16} color="var(--color-accent)" />
                    <span className="text-xs font-medium text-accent">{partner?.tier}</span>
                  </div>
                </div>

                <p className="text-text-secondary text-sm md:text-base mb-6 line-clamp-3">
                  {partner?.description}
                </p>

                <div className="space-y-4 mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon name="Calendar" size={18} color="var(--color-primary)" />
                    </div>
                    <div>
                      <div className="text-xs text-text-secondary">Partner Since</div>
                      <div className="text-sm font-semibold text-foreground">{partner?.since}</div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex items-center gap-2">
                      <Icon name="Puzzle" size={16} color="var(--color-secondary)" />
                      <div>
                        <div className="text-xs text-text-secondary">Integrations</div>
                        <div className="text-sm font-semibold text-foreground">{partner?.integrations}+</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon name="Briefcase" size={16} color="var(--color-secondary)" />
                      <div>
                        <div className="text-xs text-text-secondary">Projects</div>
                        <div className="text-sm font-semibold text-foreground">{partner?.projects}+</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-t border-border pt-4">
                  <div className="text-xs font-semibold text-foreground mb-3">Certifications</div>
                  <div className="flex flex-wrap gap-2">
                    {partner?.certifications?.map((cert, index) =>
                  <span
                    key={index}
                    className="px-3 py-1 bg-muted rounded-full text-xs text-text-secondary">

                        {cert}
                      </span>
                  )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default PremierPartners;